
import Layout from './Layout'
import UserMenu from './UserMenu.vue'

export default Layout.extend({
  name: 'MastHead',

  components: {
    UserMenu
  },

  props: {
    app: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: true
    },
    flat: {
      type: Boolean,
      default: false
    },
    clippedLeft: {
      type: Boolean,
      default: false
    }
  }
})
